'use strict';

/**
 * Values for the 'direction' attribute of a transfer
 *
 * @enum {String}
 */
module.exports = {
    UPLOAD: 'UPLOAD',
    DOWNLOAD: 'DOWNLOAD',
    SEND_LINK: 'SEND_LINK',
    FORWARD: 'FORWARD',
    RECEIVE: 'RECEIVE'
};